import { render } from "./HeaderAdmin.vue?vue&type=template&id=19928258&scoped=true"
import script from "./HeaderAdmin.vue?vue&type=script&lang=js"
export * from "./HeaderAdmin.vue?vue&type=script&lang=js"

import "./HeaderAdmin.vue?vue&type=style&index=0&id=19928258&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19928258"]])

export default __exports__